<template>
    <Col :xs="24" :sm="5" :md="5" :lg="5" :xl="5" span="5">
    <img src="../assets/images/product/homework/average_bg.png" v-if="type==1"/>
    <img src="../assets/images/product/homework/highest_bg.png" v-if="type==2"/>
    <img src="../assets/images/product/homework/lowest_bg.png" v-if="type==3"/>
    <img src="../assets/images/product/homework/average_time_bg.png" v-if="type==4"/>
    <img src="../assets/images/product/homework/number_bg.png" v-if="type==5"/>
    <img src="../assets/images/product/homework/icon_float_times.png" v-if="type==6"/>
    <img src="../assets/images/product/homework/icon_float_ques.png" v-if="type==7"/>
    <img src="../assets/images/product/homework/icon_float_sub.png" v-if="type==8"/>
    <img src="../assets/images/product/homework/icon_float_correction.png" v-if="type==9"/>

    <div class="statistic_content">
        <p class="statistic_title">{{title}}</p>
        <p class="statistic_num">
            <span class="num_left">{{leftVal}}</span>
            <span class="num_right" v-if="rightVal"> / {{rightVal}}</span>
        </p>
    </div>
    </Col>
</template>

<script>
    export default {
        name: "hw-analysis-score-item",
        props: {
            //标题
            title: {
                type: String,
                default: ''
            },
            //类别标识 1：班级平均分 2：最高分 3：最低分 4：平均用时 5：提交人数
            type: {
                type: Number,
                default: 1
            },
            //左边数
            leftVal: {
                type: String,
                default: ''
            },
            //右边数
            rightVal: {
                type: String,
                default: ''
            }
        },
        data () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import "../style/product/homework/reportList";
</style>
